import { Loader } from "lucide-react";

function LoadingSpinner() {
    return (
        <div className="flex justify-center items-center h-32">
            <Loader className="h-8 w-8 text-green-600 animate-spin" />
        </div>
    );
}

export default LoadingSpinner;
